import { render, staticRenderFns } from "./ResellerForm.vue?vue&type=template&id=51882d18&scoped=true"
import script from "./ResellerForm.vue?vue&type=script&lang=js"
export * from "./ResellerForm.vue?vue&type=script&lang=js"
import style0 from "./ResellerForm.vue?vue&type=style&index=0&id=51882d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51882d18",
  null
  
)

export default component.exports